const init = () => {

    var $teachers = $('.teachers');
    if ($teachers.length < 1) return;
    var $links = $('.teachers__link');
    var $lists = $('.teachers__list');

    /*PubSub.subscribe('app:ready', function() {
        $lists.find('li').each(function(i, el) {
            var $el = $(el);
            var link = $el.find('.btn').attr('href');
            $el.find('.teachers__title')
                .attr('href', link)
                .attr('target', '_blank');
        });
    });*/

    $links.click(function(e) {
        var $that = $(this);
        var index = $links.index($that);

        if ($that.hasClass('is-active')) {
            return;
        }

        $links.removeClass('is-active');
        $lists.removeClass('is-active');

        $that.addClass('is-active');
        $lists.eq(index).addClass('is-active');

    });

}

export default init;
